import { render } from "./ServicesAndSectorsSection.vue?vue&type=template&id=837b7e0c"
import script from "./ServicesAndSectorsSection.vue?vue&type=script&lang=js"
export * from "./ServicesAndSectorsSection.vue?vue&type=script&lang=js"

import "./ServicesAndSectorsSection.vue?vue&type=style&index=0&id=837b7e0c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__